import { Component } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { MunilyPaginationButtonsSize } from 'src/app/common-components/pagination-buttons/pagination-buttons.types';

@Component({
  selector: 'app-pagination-buttons-playground',
  templateUrl: './pagination-buttons-playground.component.html',
  styleUrls: ['./pagination-buttons-playground.component.scss'],
})
export class PaginationButtonsPlaygroundComponent {
  length = 200;
  pageIndex = 0;
  pageSize = 10;

  size: MunilyPaginationButtonsSize = 'large';
  hidePageSize = true;
  showFirstLastButtons = true;
  disabled = false;
  ariaLabel = 'Paginar lista';

  lastEvent: PageEvent | null = null;

  readonly sizes: MunilyPaginationButtonsSize[] = ['large', 'medium'];

  onPage(ev: PageEvent): void {
    this.lastEvent = ev;
    this.pageIndex = ev.pageIndex;
    this.pageSize = ev.pageSize;
  }
}
